import { render, staticRenderFns } from "./DriversEditPeriodsAvailable.vue?vue&type=template&id=025dcde2&"
import script from "./DriversEditPeriodsAvailable.vue?vue&type=script&lang=js&"
export * from "./DriversEditPeriodsAvailable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports